import { RegistrationFormData } from './registrationFormData';
import { createContext, Dispatch } from 'react';
import { RegistrationFormActions } from 'contexts/registration/actions';

export const initialState = {
  terms: false,
};

export const RegistrationFlowContext = createContext<{
  state: RegistrationFormData;
  dispatch: Dispatch<RegistrationFormActions>;
  selectFlag: string;
  setSelectFlag: (selectType: string) => void;
}>({
  state: initialState,
  dispatch: () => null,
  selectFlag: '',
  setSelectFlag: () => null,
});
